import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

export default function ProgramsPreview() {
  const programs = [
    {
      icon: 'ri-heart-pulse-line',
      title: '1 Heart Health & Wellness',
      subtitle: 'Cardiovascular Education',
      description: 'Heart Health, Mental Health, Breast Cancer Awareness, HIV Awareness, Domestic Violence Prevention & Wellness',
      color: 'coral',
      bgColor: 'bg-coral/10',
      borderColor: 'border-coral',
      link: '/programs#heart-health'
    },
    {
      icon: 'ri-leaf-line',
      title: 'Align & Restore',
      subtitle: 'Wellness Products',
      description: 'Wellness Shots, Supplements, Massage Oils & Aromatherapy, Swagh Health Wellness',
      color: 'teal',
      bgColor: 'bg-teal/10',
      borderColor: 'border-teal',
      link: '/programs#align-restore'
    },
    {
      icon: 'ri-mic-line',
      title: 'The Story Coach',
      subtitle: 'Wellness Introduction',
      description: 'Motivational Coaching & Inspiring Stories, Personal Growth & Media',
      color: 'charcoal',
      bgColor: 'bg-charcoal/10',
      borderColor: 'border-charcoal',
      link: '/programs#story-coach'
    },
    {
      icon: 'ri-book-open-line',
      title: 'Books & Design',
      subtitle: 'Creative Works',
      description: 'Author, Fashion & Design, Shop / Explore',
      color: 'purple',
      bgColor: 'bg-purple/10',
      borderColor: 'border-purple',
      link: '/books'
    }
  ];

  return (
    <section className="py-20 bg-cream">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Grid of 4 Programs */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
          {programs.map((program, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className={`${program.bgColor} border-2 ${program.borderColor} rounded-2xl p-6 hover:shadow-xl transition-all cursor-pointer group`}
            >
              <div className={`w-16 h-16 flex items-center justify-center bg-white rounded-full mb-4 mx-auto`}>
                <i className={`${program.icon} text-3xl text-${program.color}`}></i>
              </div>
              
              <h3 className="font-serif text-xl font-bold text-charcoal text-center mb-2">
                {program.title}
              </h3>
              
              <p className={`text-sm font-semibold text-${program.color} text-center mb-3`}>
                {program.subtitle}
              </p>
              
              <p className="text-sm text-charcoal/70 text-center leading-relaxed mb-4">
                {program.description}
              </p>

              <div className="text-center">
                <Link
                  to={program.link}
                  className={`inline-block bg-${program.color} text-white px-6 py-2 rounded-full text-xs font-semibold hover:opacity-90 transition-all whitespace-nowrap`}
                >
                  LEARN MORE
                </Link>
              </div>
            </motion.div>
          ))}
        </div>

        {/* Bottom CTA Section */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center bg-white rounded-2xl p-12 shadow-lg"
        >
          <h3 className="font-serif text-3xl font-bold text-charcoal mb-4">
            Join Our Community: Transform Your Life.
          </h3>
          <p className="text-charcoal/70 mb-6 max-w-2xl mx-auto">
            "1 Heart Health & Wellness has been a beacon of hope. Their wellness programs and inspiring stories have transformed my life." - Community Member
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <Link
              to="/get-involved"
              className="bg-coral text-white px-8 py-3 rounded-full font-semibold hover:bg-coral/90 transition-all shadow-md hover:shadow-lg whitespace-nowrap cursor-pointer text-sm"
            >
              Subscribe to Newsletter
            </Link>
            <Link
              to="/donate"
              className="bg-charcoal text-white px-8 py-3 rounded-full font-semibold hover:bg-coral/90 transition-all shadow-md hover:shadow-lg whitespace-nowrap cursor-pointer text-sm"
            >
              Donate / Support Our Mission
            </Link>
          </div>
        </motion.div>
      </div>
    </section>
  );
}